import axios from '@/axiosInterceptor';

const state = () => ({
  results: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  },
});

// getters
const getters = {};

// actions
const actions = {
  async getMyUserInvitations({ commit }, { page, searchQuery = '' }) {
    try {
      let res = await axios.get(
        `${process.env.API_IDENTITY}/api/v1/user_invitations?q[s]=delivered_at desc&page=${page}&per_page=50${searchQuery}`
      );
      commit('setUserInvitations', res.data);
      console.log(res.headers);
      commit('setPagination', res.headers);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async createUserInvitation({ commit }, { email, scopes, site }) {
    // The site for this app is process.env.SITE_DOMAIN.  This will control the format of the email to the
    // user.  If we are on highway.com, we need to make sure we use highway.com
    // See the highway-identity service UserInvitation model for more detail.
    const data = { user_invitation: { email, scopes, site } };
    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/user_invitations',
        data
      );
      if (res.ok) {
        commit('newUserInvitation', res.data);
      }
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async resendUserInvitation(_, { email, id }) {
    const data = {
      user_invitation: { email, scopes: ['sourcing', 'manage_users'] },
    };
    try {
      let res = await axios.patch(
        `${process.env.API_IDENTITY}/api/v1/user_invitations/${id}/resend`,
        data
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async deleteUserInvitation({ commit }, id) {
    try {
      let res = await axios.delete(
        process.env.API_IDENTITY + '/api/v1/user_invitations/' + id
      );
      commit('deleteUserInvitation', id);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  newUserInvitation(state, data) {
    state.results.unshift(data);
  },
  setUserInvitations(state, data) {
    state.results = data;
  },
  setPagination(state, headers) {
    state.pagination = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  deleteUserInvitation(state, id) {
    state.results = state.results.filter(function (savedSearch) {
      return savedSearch.id != id;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
